/* octomech — tema davranışları.
 *
 * Hydrogen sürümünde her biri ayrı React bileşeniydi (Preloader, CursorGlow,
 * DustParticles, MagneticButton, SmoothScroll, Showcase, useReveals). Burada
 * hepsi tek dosyada düz JavaScript; mantık ve sayılar oradan birebir alındı.
 *
 * Sepet kısmı yeniden yazıldı: Hydrogen Storefront API ile konuşuyordu,
 * burada Shopify'ın AJAX Cart API'si var.
 */
(function () {
  'use strict';

  var azHareket = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, k) { return (k || document).querySelector(s); };
  var $$ = function (s, k) { return Array.prototype.slice.call((k || document).querySelectorAll(s)); };

  /* ── GSAP eklentisi ────────────────────────────────────────────────
     Kayıt burada, kullanmadan önce. Hydrogen'de kayıt SmoothScroll'un
     içindeydi ve Showcase ondan önce çalışıp "_context is not a function"
     ile düşüyordu — aynı hataya düşmeyelim. */
  var gsapVar = window.gsap;
  if (gsapVar && window.ScrollTrigger) gsapVar.registerPlugin(window.ScrollTrigger);

  /* ── Perde ─────────────────────────────────────────────────────── */
  function perde() {
    var kok = $('[data-preloader]');
    if (!kok) return;
    var bar = $('[data-preloader-bar]');
    var sayac = $('[data-preloader-sayac]');
    var bitti = false;
    var bitir = function () {
      if (bitti) return;
      bitti = true;
      if (kok.parentNode) kok.remove();
      document.documentElement.classList.add('octomech-hazir');
    };

    /* Emniyet: ne olursa olsun perde 2,5 saniyeden fazla kalmaz.
       GSAP gelmezse, bir hata atarsa veya bağlantı yavaşsa sayfa açılır. */
    setTimeout(bitir, 2500);

    /* Oturumda yalnızca ilk ziyarette göster — sayfa geçişlerinde tekrarlama. */
    var gorundu = false;
    try { gorundu = sessionStorage.getItem('octomech-perde') === '1'; } catch (e) {}
    if (gorundu || azHareket || !gsapVar) { bitir(); return; }
    try { sessionStorage.setItem('octomech-perde', '1'); } catch (e) {}

    var d = { v: 0 };
    var tl = gsapVar.timeline();
    // Marka anı kısa: toplam ~0,85 sn
    tl.to(d, {
      v: 100, duration: 0.5, ease: 'power3.inOut',
      onUpdate: function () {
        if (sayac) sayac.textContent = String(Math.round(d.v)).padStart(3, '0');
        if (bar) bar.style.transform = 'scaleX(' + d.v / 100 + ')';
      }
    });
    tl.to(kok, { yPercent: -100, duration: 0.35, ease: 'expo.inOut', onComplete: bitir });
  }

  /* ── İmleç ışığı ───────────────────────────────────────────────── */
  function imlec() {
    if (window.matchMedia('(hover: none)').matches) return;
    var genis = $('[data-imlec-genis]');
    var nokta = $('[data-imlec-nokta]');
    if (!genis || !nokta) return;

    var p = { x: innerWidth / 2, y: innerHeight / 2 };
    var g = { x: p.x, y: p.y };
    var n = { x: p.x, y: p.y };
    addEventListener('mousemove', function (e) { p.x = e.clientX; p.y = e.clientY; }, { passive: true });
    (function tik() {
      g.x += (p.x - g.x) * 0.06; g.y += (p.y - g.y) * 0.06;
      n.x += (p.x - n.x) * 0.2;  n.y += (p.y - n.y) * 0.2;
      genis.style.transform = 'translate3d(' + g.x + 'px,' + g.y + 'px,0)';
      nokta.style.transform = 'translate3d(' + n.x + 'px,' + n.y + 'px,0)';
      requestAnimationFrame(tik);
    })();
  }

  /* ── Toz parçacıkları ──────────────────────────────────────────── */
  function toz() {
    var c = $('[data-toz]');
    if (!c || azHareket) return;
    var ctx = c.getContext('2d');
    if (!ctx) return;

    var w = 0, h = 0, raf = 0, zerre = [];
    var dpr = Math.min(devicePixelRatio, 2);
    var adet = innerWidth < 700 ? 26 : 46;

    function olcu() {
      var r = c.getBoundingClientRect();
      w = r.width; h = r.height;
      c.width = w * dpr; c.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function ek() {
      zerre = [];
      for (var i = 0; i < adet; i++) zerre.push({
        x: Math.random() * w, y: Math.random() * h,
        r: 0.6 + Math.random() * 1.8,
        vx: -0.06 - Math.random() * 0.12,
        vy: -0.03 - Math.random() * 0.08,
        faz: Math.random() * Math.PI * 2,
        a: 0.12 + Math.random() * 0.25
      });
    }
    function tik(t) {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < zerre.length; i++) {
        var m = zerre[i];
        m.x += m.vx + Math.sin(t / 2400 + m.faz) * 0.08;
        m.y += m.vy;
        if (m.y < -4 || m.x < -4) { m.x = w + Math.random() * 20; m.y = Math.random() * h; }
        var parilti = 0.7 + 0.3 * Math.sin(t / 900 + m.faz * 3);
        ctx.beginPath();
        ctx.arc(m.x, m.y, m.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,238,214,' + m.a * parilti + ')';
        ctx.fill();
      }
      raf = requestAnimationFrame(tik);
    }
    olcu(); ek(); raf = requestAnimationFrame(tik);
    addEventListener('resize', function () { olcu(); ek(); }, { passive: true });
    // Sekme arkadayken boşuna çizme
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) cancelAnimationFrame(raf);
      else raf = requestAnimationFrame(tik);
    });
  }

  /* ── Mıknatıslı butonlar ───────────────────────────────────────── */
  function miknatis() {
    if (!gsapVar || azHareket || window.matchMedia('(hover: none)').matches) return;
    $$('[data-miknatis]').forEach(function (el) {
      var guc = 18;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width - 0.5) * 2;
        var y = ((e.clientY - r.top) / r.height - 0.5) * 2;
        gsapVar.to(el, { x: x * guc, y: y * guc * 0.7, duration: 0.4, ease: 'power2.out' });
      });
      el.addEventListener('mouseleave', function () {
        gsapVar.to(el, { x: 0, y: 0, duration: 0.9, ease: 'elastic.out(1, 0.35)' });
      });
    });
  }

  /* ── Yumuşak kaydırma ──────────────────────────────────────────── */
  var lenis = null;
  function yumusakKaydirma() {
    if (azHareket || !window.Lenis || !gsapVar) return;
    lenis = new window.Lenis({
      duration: 1.15,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true
    });
    window.lenis = lenis;
    if (window.ScrollTrigger) lenis.on('scroll', window.ScrollTrigger.update);
    gsapVar.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsapVar.ticker.lagSmoothing(0);
  }

  /* ── Giriş animasyonları ───────────────────────────────────────── */
  function acilislar() {
    if (!gsapVar || azHareket || !window.ScrollTrigger) return;
    $$('[data-reveal]').forEach(function (el) {
      gsapVar.fromTo(el,
        { opacity: 0, y: 42, filter: 'blur(12px)' },
        { opacity: 1, y: 0, filter: 'blur(0px)', duration: 1.15, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 86%', once: true } });
    });
    $$('[data-img-reveal]').forEach(function (el) {
      var img = el.querySelector('img');
      gsapVar.fromTo(el,
        { clipPath: 'inset(100% 0% 0% 0%)' },
        { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.4, ease: 'power3.inOut',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
      if (img) gsapVar.fromTo(img, { scale: 1.22 },
        { scale: 1, duration: 1.9, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
    });
    $$('[data-parallax]').forEach(function (el) {
      var hiz = parseFloat(el.dataset.parallax || '0.1');
      gsapVar.fromTo(el, { y: hiz * 220 }, { y: hiz * -220, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
  }

  /* ── Hero giriş ────────────────────────────────────────────────── */
  function heroGiris() {
    var h = $('[data-hero]');
    if (!h) return;
    var hedefler = ['.hero__eyebrow', '.hero__copy', '.hero__ctas', '.hero__offer', '.hero__stage', '.hero__scroll-cue']
      .map(function (s) { return $(s, h); }).filter(Boolean);
    if (azHareket || !gsapVar) { hedefler.forEach(function (e) { e.style.opacity = 1; }); return; }

    var tl = gsapVar.timeline({ delay: 0.85 });
    var satirlar = $$('.hero__title .line span', h);
    if (satirlar.length) {
      gsapVar.set(satirlar, { yPercent: 110 });
      tl.to(satirlar, { yPercent: 0, duration: 1.1, ease: 'power4.out', stagger: 0.09 });
    }
    tl.fromTo(hedefler, { opacity: 0, y: 18 },
      { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out', stagger: 0.08 }, '-=0.6');
  }

  /* ── Nav davranışı ─────────────────────────────────────────────── */
  function nav() {
    var n = $('[data-nav]');
    if (!n) return;
    var sonY = scrollY;
    addEventListener('scroll', function () {
      var y = scrollY;
      n.classList.toggle('nav--scrolled', y > 24);
      n.classList.toggle('nav--hidden', y > 600 && y > sonY && !document.body.classList.contains('menu-acik'));
      sonY = y;
    }, { passive: true });

    var dugme = $('[data-menu-ac]');
    var katman = $('[data-menu-katman]');
    if (dugme && katman) {
      dugme.addEventListener('click', function () {
        var acik = katman.classList.toggle('nav-overlay--open');
        document.body.classList.toggle('menu-acik', acik);
        dugme.textContent = acik ? 'Kapat' : 'Menü';
      });
      $$('a', katman).forEach(function (a) {
        a.addEventListener('click', function () {
          katman.classList.remove('nav-overlay--open');
          document.body.classList.remove('menu-acik');
          dugme.textContent = 'Menü';
        });
      });
    }
  }

  /* ── Çapa kaydırma ─────────────────────────────────────────────── */
  function capa() {
    function git(hedef) {
      if (lenis) lenis.scrollTo(hedef, { offset: -20, duration: 1.4 });
      else hedef.scrollIntoView({ behavior: azHareket ? 'auto' : 'smooth' });
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#"]');
      if (!a) return;
      var url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname || !url.hash) return;  // başka sayfa → normal git
      var hedef = document.querySelector(url.hash);
      if (!hedef) return;
      e.preventDefault();
      history.pushState(null, '', url.hash);
      git(hedef);
    });
    // Başka sayfadan çapayla gelindiyse
    if (location.hash) {
      var h = document.querySelector(location.hash);
      if (h) setTimeout(function () { git(h); }, 400);
    }
  }

  /* ── Kategori filtresi ─────────────────────────────────────────── */
  function filtre() {
    var dugmeler = $$('[data-filtre]');
    if (!dugmeler.length) return;
    dugmeler.forEach(function (d) {
      d.addEventListener('click', function () {
        var secim = d.dataset.filtre;
        dugmeler.forEach(function (x) {
          var on = x === d;
          x.classList.toggle('filter--on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        $$('[data-kategori]').forEach(function (g) {
          g.hidden = secim !== '' && g.dataset.kategori !== secim;
        });
        if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      });
    });
  }

  /* ── Sepet ─────────────────────────────────────────────────────── */
  function sepet() {
    var kok = function () { return $('[data-sepet]'); };

    function ac() {
      var s = kok(); if (!s) return;
      s.classList.add('cart--open');
      s.setAttribute('aria-hidden', 'false');
      var perde = $('[data-sepet-perde]');
      if (perde) perde.classList.add('cart-scrim--on');
      if (lenis) lenis.stop();
    }
    function kapat() {
      var s = kok(); if (!s) return;
      s.classList.remove('cart--open');
      s.setAttribute('aria-hidden', 'true');
      var perde = $('[data-sepet-perde]');
      if (perde) perde.classList.remove('cart-scrim--on');
      if (lenis) lenis.start();
    }

    /* Çekmecenin içini Shopify'a yeniden çizdir. Fiyat, indirim ve toplam
       hep sunucudan gelsin — kodda hesaplarsak sepet ile ödeme sayfası
       ayrışabilir. */
    function tazele(sonra) {
      /* DİKKAT: buraya "Accept: application/json" başlığı KOYMA.
         O başlıkla Shopify istenen bölümü değil şablonun ana bölümünü
         döndürüyor — ürün sayfasında anahtar "octomech-cart-drawer" yerine
         "product" geliyor ve sepet hiç güncellenmiyordu. Başlıksız istek
         doğru bölümü veriyor. */
      fetch(location.pathname + '?sections=octomech-cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var html = d['octomech-cart-drawer'];
          if (!html) {
            console.warn('[sepet] bölüm gelmedi, dönen anahtarlar:', Object.keys(d));
            return;
          }
          var yeni = new DOMParser().parseFromString(html, 'text/html');
          var yeniSepet = yeni.querySelector('[data-sepet]');
          var eski = kok();
          if (yeniSepet && eski) {
            var acikMi = eski.classList.contains('cart--open');
            eski.replaceWith(yeniSepet);
            if (acikMi) { yeniSepet.classList.add('cart--open'); yeniSepet.setAttribute('aria-hidden', 'false'); }
          }
          rozetGuncelle();
          if (sonra) sonra();
        })
        .catch(function (e) { console.warn('[sepet] tazelenemedi:', e); });
    }

    function rozetGuncelle() {
      fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var rozet = $('[data-sepet-sayi]');
          if (rozet) { rozet.textContent = c.item_count; rozet.hidden = c.item_count === 0; }
        })
        .catch(function () {});
    }

    /* Shopify sepet hatalarını 422 ile ve Türkçe bir mesajla döndürüyor
       ("Stok durumu nedeniyle sepetinize yalnızca 1 ürün eklendi" gibi).
       Önce bu sessizce yutuluyordu: adet değişmiyor, müşteri neden
       olduğunu anlamıyordu. Artık mesaj çekmecede gösteriliyor. */
    function istek(url, govde) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(govde)
      }).then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) {
            var e = new Error(d.description || d.message || 'Sepet güncellenemedi.');
            e.kullaniciMesaji = d.description || d.message;
            throw e;
          }
          return d;
        });
      });
    }

    function hataGoster(mesaj) {
      var s = kok(); if (!s) return;
      var eski = $('.cart__hata', s);
      if (eski) eski.remove();
      var kutu = document.createElement('p');
      kutu.className = 'cart__hata';
      kutu.setAttribute('role', 'status');
      kutu.textContent = mesaj;
      var bas = $('.cart__head', s);
      if (bas && bas.nextSibling) s.insertBefore(kutu, bas.nextSibling);
      else s.appendChild(kutu);
      setTimeout(function () { if (kutu.parentNode) kutu.remove(); }, 6000);
    }

    // Aç / kapat
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sepet-ac]')) { e.preventDefault(); ac(); }
      else if (e.target.closest('[data-sepet-kapat]') || e.target.closest('[data-sepet-perde]')) kapat();
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') kapat(); });

    // Sepete ekle — form gönderimini kesip AJAX'a çevir
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-sepete-ekle-form]');
      if (!form) return;
      e.preventDefault();
      /* Gönderen düğme: "Sepete ekle" mi "Hemen al" mı. Eskiden formun ilk
         submit düğmesi alınıyordu; iki düğme olunca yanlış olana "Ekleniyor…"
         yazıyordu. */
      var dugme = (e.submitter && form.contains(e.submitter)) ? e.submitter : form.querySelector('button[type=submit]');
      var hemenAl = !!(dugme && dugme.hasAttribute('data-hemen-al'));
      if (dugme) { dugme.disabled = true; dugme.dataset.eskiYazi = dugme.textContent.trim(); dugme.textContent = hemenAl ? 'Yönlendiriliyor…' : 'Ekleniyor…'; }
      istek(window.routes.cart_add_url + '.js', {
        id: form.querySelector('[name=id]').value,
        quantity: parseInt(form.querySelector('[name=quantity]').value, 10) || 1
      }).then(function () {
        /* "Hemen al" sepeti atlıyor. Ekleme BAŞARILI olmadan yönlendirme yok;
           aksi hâlde müşteri boş sepetle ödeme sayfasında kalırdı. */
        if (hemenAl) { window.location.href = '/checkout'; return; }
        tazele(ac);
      }).catch(function (err) {
        console.warn('[sepet] eklenemedi:', err);
        ac();
        hataGoster(err.kullaniciMesaji || 'Ürün sepete eklenemedi. Tekrar dener misin?');
      }).finally(function () {
        if (dugme && !hemenAl) { dugme.disabled = false; dugme.textContent = dugme.dataset.eskiYazi || 'Sepete ekle'; }
      });
    });

    // Adet, silme, boşaltma
    document.addEventListener('click', function (e) {
      var adetDugme = e.target.closest('[data-sepet-adet]');
      var silDugme = e.target.closest('[data-sepet-sil]');
      var bosalt = e.target.closest('[data-sepet-bosalt]');

      if (adetDugme) {
        istek(window.routes.cart_change_url + '.js',
          { id: adetDugme.dataset.sepetAdet, quantity: parseInt(adetDugme.dataset.adet, 10) })
          .then(function () { tazele(); })
          .catch(function (err) {
            /* Mesajı tazelemeden SONRA göster: tazele() çekmecenin içini
               baştan yazıyor, önce eklenen uyarı siliniyordu. */
            var mesaj = err.kullaniciMesaji || 'Adet değiştirilemedi.';
            tazele(function () { hataGoster(mesaj); });
          });
      } else if (silDugme) {
        istek(window.routes.cart_change_url + '.js', { id: silDugme.dataset.sepetSil, quantity: 0 })
          .then(function () { tazele(); })
          .catch(function (err) { hataGoster(err.kullaniciMesaji || 'Ürün kaldırılamadı.'); });
      } else if (bosalt) {
        fetch(window.routes.cart_url + '/clear.js', { method: 'POST' }).then(function () { tazele(); });
      }
    });
  }


  /* ── Sabitlenen showcase ───────────────────────────────────────── */
  function showcase() {
    var kok = $('[data-showcase]');
    if (!kok || azHareket || !gsapVar || !window.ScrollTrigger) return;

    // Bölümün tamamı düşmesin diye korumada: Hydrogen'de bu kurulum
    // "_context is not a function" ile patlamış ve sessizce yutulmuştu.
    try {
      var adimlar = $$('.showcase__step', kok);
      var fotolar = $$('.showcase__shot-sar', kok);
      var barlar = $$('.showcase__progress i', kok);
      if (!adimlar.length) return;

      window.ScrollTrigger.create({
        trigger: kok,
        start: 'top top',
        // Anlatım satın alma yolunu uzatmasın: 280% -> 160%
        end: '+=160%',
        pin: '.showcase__pin',
        scrub: true,
        invalidateOnRefresh: true,
        onUpdate: function (self) {
          var p = self.progress;
          var dilim = 1 / adimlar.length;
          adimlar.forEach(function (adim, i) {
            var yerel = gsapVar.utils.clamp(0, 1, (p - i * dilim) / dilim);
            var gir = gsapVar.utils.clamp(0, 1, yerel / 0.25);
            var cik = i === adimlar.length - 1 ? 1 : gsapVar.utils.clamp(0, 1, (1 - yerel) / 0.25);
            var o = Math.min(gir, cik);
            adim.style.opacity = String(o);
            adim.style.transform = 'translateY(calc(-50% + ' + (1 - gir) * 26 + 'px))';
            if (barlar[i]) barlar[i].style.setProperty('--p', String(yerel));
            if (fotolar[i]) {
              fotolar[i].style.opacity = String(o);
              fotolar[i].style.transform = 'scale(' + (0.96 + 0.04 * gir) + ')';
            }
          });
        }
      });
    } catch (e) {
      console.warn('[showcase] sabitleme kurulamadı:', e);
    }
  }

  /* ── Ürün sayfası adet seçici ──────────────────────────────────── */
  function adetSecici() {
    var goster = $('[data-adet-goster]');
    var girdi = $('[data-adet-girdi]');
    if (!goster || !girdi) return;
    var azalt = $('[data-adet-azalt]');
    var artir = $('[data-adet-artir]');
    var MAKS = 10;   // Hydrogen'deki MAX_QTY ile aynı
    var n = 1;

    function ciz() {
      goster.textContent = n;
      girdi.value = n;
      if (azalt) azalt.disabled = n <= 1;
      if (artir) artir.disabled = n >= MAKS;
    }
    if (azalt) azalt.addEventListener('click', function () { n = Math.max(1, n - 1); ciz(); });
    if (artir) artir.addEventListener('click', function () { n = Math.min(MAKS, n + 1); ciz(); });
    ciz();
  }

  /* ── Renk seçici ───────────────────────────────────────────────── */
  /* Noktalar gerçek `?variant=` bağlantısı; JS olmasa da renk seçilir,
     sayfa yeniden yüklenir. Burada tıklama yakalanıp bölüm yerinde
     tazeleniyor: fotoğraf, fiyat, SKU, özellik satırı ve seçicinin
     kendisi değişiyor, sayfa zıplamıyor. */
  function renkSecici() {
    /* Ürünün her seçeneği (Renk, Başlık…) kendi grubunu çiziyor;
       burada hepsi birden yönetiliyor. Tek grup varsayan eski sürümde
       iki seçenekli üründe ikinci grup kilitli kalıyordu. */
    if (!$('[data-varyant-secici]')) return;

    var form = $('[data-sepete-ekle-form]');
    var yukleniyor = false;

    function tazele(url, odak) {
      if (yukleniyor) return;
      yukleniyor = true;

      /* Bölüm anahtarı dosya adı: "octomech-product".
         templates/product.json'daki "main" DEĞİL — o denendi, Shopify
         { "main": "" } yani boş dize döndürüyor ve her tıklamada yedek
         yola (tam sayfa yükleme) düşülüyordu.

         Sepet çekmecesinde olduğu gibi buraya da "Accept: application/json"
         KOYMA; o başlıkla Shopify istenen bölüm yerine şablonun ana
         bölümünü döndürüyor. */
      var ayrac = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + ayrac + 'sections=octomech-product')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var html = d['octomech-product'];
          if (!html) {
            console.warn('[renk] bölüm gelmedi, dönen anahtarlar:', Object.keys(d));
            location.href = url;   // yedek yol: normal gezinme
            return;
          }
          var yeni = new DOMParser().parseFromString(html, 'text/html');
          var parcalar = document.querySelectorAll('[data-varyant-parca]');
          for (var i = 0; i < parcalar.length; i++) {
            var ad = parcalar[i].getAttribute('data-varyant-parca');
            var karsilik = yeni.querySelector('[data-varyant-parca="' + ad + '"]');
            if (karsilik) parcalar[i].replaceWith(karsilik);
          }

          /* Sepete eklenecek varyant. Form tazelenen parçaların dışında
             kaldığı için elle güncelleniyor. */
          var yeniId = yeni.querySelector('[name="id"]');
          var eskiId = form && form.querySelector('[name="id"]');
          if (yeniId && eskiId) eskiId.value = yeniId.value;

          /* Adres çubuğu da değişsin: sayfayı yenileyen ya da bağlantıyı
             paylaşan kişi aynı rengi görsün. */
          history.replaceState({}, '', url);

          baglaOkTuslari();
          /* Klavyeyle gezilirken odak, tazelenen bölümde aynı grubun aynı
             sırasına geri konuyor; yoksa odak gövdeye düşüp gezinme kopuyor. */
          if (odak) {
            var gruplar = document.querySelectorAll('[data-varyant-secici]');
            var grup = gruplar[odak.grup];
            if (grup) {
              var noktalar = grup.querySelectorAll('.swatch');
              if (noktalar[odak.nokta]) noktalar[odak.nokta].focus();
            }
          }
        })
        .catch(function () { location.href = url; })
        .then(function () { yukleniyor = false; });
    }

    /* Ok tuşları seçim değiştirir — WAI-ARIA radiogroup davranışı.
       Ok tuşu grubun içinde dönüyor: renkteyken sağa basmak başlık
       grubuna atlamıyor, iki grup ayrı radiogroup. */
    function baglaOkTuslari() {
      var gruplar = document.querySelectorAll('[data-varyant-secici]');
      Array.prototype.forEach.call(gruplar, function (grup, gi) {
        var noktalar = grup.querySelectorAll('.swatch');
        Array.prototype.forEach.call(noktalar, function (nokta, i) {
          nokta.addEventListener('keydown', function (e) {
            var yon =
              e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 :
              e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
            if (!yon) return;
            e.preventDefault();
            var sonraki = (i + yon + noktalar.length) % noktalar.length;
            tazele(noktalar[sonraki].getAttribute('href'), { grup: gi, nokta: sonraki });
          });
        });
      });
    }

    /* Seçici her tazelemede yenilendiği için tıklama belgeye bağlanıyor. */
    document.addEventListener('click', function (e) {
      var nokta = e.target.closest && e.target.closest('[data-varyant-secici] .swatch');
      if (!nokta) return;
      e.preventDefault();
      tazele(nokta.getAttribute('href'), null);
    });

    baglaOkTuslari();
  }

  /* ── Kampanya geri sayımı ──────────────────────────────────────── */
  /* Bitiş anı sunucuda Unix saniyesi olarak basılıyor (Türkiye saati).
     Sayaç yenilemeyle başa dönmüyor; bitiş geçince şerit kaldırılıyor —
     sayfa önbellekten gelmiş olsa bile süresi dolmuş kampanya görünmesin. */
  function kampanyaSayac() {
    /* Şerit ve ana sayfa bölümü aynı bitiş anını taşıyor; tek zamanlayıcı
       ikisini birden güncelliyor. Şerit düz metin ("16 gün 04:12:33"),
       bölüm ayrı kutular (data-k-gun / saat / dk / sn) kullanıyor. */
    var yerler = document.querySelectorAll('[data-kampanya]');
    if (!yerler.length) return;
    var son = parseInt(yerler[0].getAttribute('data-bitis'), 10) * 1000;
    if (!son) return;
    var zamanlayici = null;
    function iki(n) { return n < 10 ? '0' + n : String(n); }
    function yaz(el, sec, deger) {
      /* querySelectorAll: kayan yazıda mesaj tekrarlandığı için aynı
         sayaç şeritte altı kez geçiyor, hepsi aynı anda güncellenmeli. */
      var hepsi = el.querySelectorAll(sec);
      for (var i = 0; i < hepsi.length; i++) hepsi[i].textContent = deger;
    }
    function ciz() {
      var kalan = son - Date.now();
      if (kalan <= 0) {
        if (zamanlayici) clearInterval(zamanlayici);
        Array.prototype.forEach.call(yerler, function (el) { el.remove(); });
        return;
      }
      var s = Math.floor(kalan / 1000);
      var gun = Math.floor(s / 86400); s -= gun * 86400;
      var sa = Math.floor(s / 3600); s -= sa * 3600;
      var dk = Math.floor(s / 60); s -= dk * 60;
      Array.prototype.forEach.call(yerler, function (el) {
        yaz(el, '[data-kampanya-sayac]', (gun > 0 ? gun + ' gün ' : '') + iki(sa) + ':' + iki(dk) + ':' + iki(s));
        yaz(el, '[data-k-gun]', iki(gun));
        yaz(el, '[data-k-saat]', iki(sa));
        yaz(el, '[data-k-dk]', iki(dk));
        yaz(el, '[data-k-sn]', iki(s));
      });
    }
    ciz();
    zamanlayici = setInterval(ciz, 1000);
  }

  /* ── Şerit: dönen duyuru ───────────────────────────────────────── */
  /* 5 saniyede bir sıradaki mesaja geçer. Çıkan yukarı kayıp söner,
     gelen aşağıdan gelir. Fare üstündeyken ve sekme arkadayken durur.
     Şerit kampanya bitince DOM'dan kaldırılıyor; o zaman döngü de biter. */
  function seritDongu() {
    var serit = $('[data-kampanya-serit]');
    if (!serit) return;
    var ogeler = serit.querySelectorAll('[data-serit-oge]');
    if (ogeler.length < 2) return;
    var sira = 0;
    var durdu = false;
    serit.addEventListener('mouseenter', function () { durdu = true; });
    serit.addEventListener('mouseleave', function () { durdu = false; });
    var zamanlayici = setInterval(function () {
      if (!serit.isConnected) { clearInterval(zamanlayici); return; }
      if (durdu || document.hidden) return;
      var cikan = ogeler[sira];
      sira = (sira + 1) % ogeler.length;
      var gelen = ogeler[sira];
      cikan.classList.remove('is-aktif');
      cikan.classList.add('is-cikis');
      cikan.setAttribute('aria-hidden', 'true');
      gelen.classList.add('is-aktif');
      gelen.removeAttribute('aria-hidden');
      /* Geçiş bitince çıkanı başlangıç konumuna (aşağı) görünmeden al */
      setTimeout(function () { cikan.classList.remove('is-cikis'); }, 600);
    }, 5000);
  }

  /* ── Başlat ────────────────────────────────────────────────────── */
  function baslat() {
    perde(); imlec(); toz(); miknatis();
    yumusakKaydirma(); acilislar(); heroGiris();
    nav(); capa(); filtre(); sepet();
    showcase(); adetSecici(); renkSecici(); kampanyaSayac(); seritDongu();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
})();


/* ───────────────────────── Mobil satın alma çubuğu ─────────────────────────
   Uzun ürün sayfasında asıl düğme yukarıda kalıyor. Çubuk yalnızca o düğme
   ekrandan çıktığında beliriyor; dururken görünüp dikkat dağıtmıyor.
   Çubuktaki düğme asıl formu gönderiyor — ikinci bir sepet yolu açmıyoruz,
   tek kaynak var ve varyant seçimi orada.                                   */
(function () {
  var cubuk = document.querySelector('[data-satin-cubuk]');
  var ctas = document.querySelector('.product-info__ctas');
  if (!cubuk || !ctas || !('IntersectionObserver' in window)) return;

  /* Durumu kutuyu kendimiz ölçerek belirliyoruz, gözcünün ilk raporunu
     bekleyerek değil. IntersectionObserver yalnızca kesişme DEĞİŞTİĞİNDE
     haber veriyor; telefonda asıl düğme sayfa açılır açılmaz zaten katın
     altında kalıyor (375x812'de üstü 940px) ve ilk rapor gecikirse çubuk
     hiç belirmiyor — yani ilk ekranda ne fiyat ne de sepet düğmesi oluyor.
     Gözcü duruyor, kaydırmayı ucuz şekilde o takip ediyor; açılış, yükleme
     ve yeniden boyutlanma anlarında ölçümü biz yapıyoruz. */
  function tazele() {
    var r = ctas.getBoundingClientRect();
    var sinir = window.innerHeight - 40;   /* gözcüdeki -40px payının eşi */
    if (r.bottom > 0 && r.top < sinir) cubuk.setAttribute('hidden', '');
    else cubuk.removeAttribute('hidden');
  }

  new IntersectionObserver(tazele, { rootMargin: '0px 0px -40px 0px' }).observe(ctas);
  window.addEventListener('load', tazele);
  window.addEventListener('resize', tazele);
  tazele();

  cubuk.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cubuk-ekle]')) return;
    var form = document.querySelector('[data-sepete-ekle-form]');
    if (!form) return;
    /* requestSubmit: tarayıcının kendi doğrulamasını çalıştırır ve submit
       olayını tetikler. form.submit() olayı ATLAR, AJAX akışı devreye girmez
       ve sayfa yeniden yüklenirdi. */
    if (form.requestSubmit) form.requestSubmit();
    else form.querySelector('button[type=submit]').click();
  });
})();


/* ──────────── Sohbet balonu ile satın alma çubuğunu çakıştırma ────────────
   Ölçüm (375x812, ürün sayfası): Shopify Inbox balonu x 240–355 / y 742–792,
   çubuktaki "Sepete ekle" x 217–357 / y 747–798. Tam üst üsteydiler ve
   Inbox'ın z-index'i 2147483000 olduğu için dokunuş sepete değil sohbete
   gidiyordu — yani telefonda o düğme hiç çalışmıyordu.

   Balonun kendisi kapalı bir kutuda değil: <shopify-chat> açık bir shadow
   root taşıyor, ama içine CSS yazamıyoruz. Bu yüzden barındıran elemanı
   (tüm ekranı kaplayan, pointer-events:none olan sabit katman) yukarı
   kaydırıyoruz. Sohbet AÇILDIĞINDA kaydırmayı geri alıyoruz, yoksa panelin
   üstü ekrandan taşardı; açık olup olmadığını shadow root'taki en yüksek
   kutudan anlıyoruz (kapalıyken yalnızca ~50px'lik düğme var).

   Kalıcı çözüm Inbox ayarından balonu sola almak; bu kod o yapılmasa da
   düğmeyi açıkta tutuyor ve sola alınırsa kendiliğinden devre dışı kalıyor
   (çakışma yoksa kaydırma da yok).                                         */
(function () {
  var cubuk = document.querySelector('[data-satin-cubuk]');
  if (!cubuk) return;

  var host = null;
  var bekleyen = false;

  function sohbetAcik(sr) {
    var hepsi = sr.querySelectorAll('*');
    for (var i = 0; i < hepsi.length; i++) {
      if (hepsi[i].getBoundingClientRect().height > 160) return true;
    }
    return false;
  }

  function cakisiyor(sr) {
    /* Çubuğun TAMAMIYLA karşılaştırıyoruz, yalnızca düğmesiyle değil:
       balon sağdaysa "Sepete ekle"nin, soldaysa ürün adı ile fiyatın
       üstüne biniyor. İkisi de istenmiyor, ikisinde de yukarı kaldırıyoruz.
       Kesişme yoksa (balon başka yerdeyse) hiç kıpırdatmıyoruz. */
    var balon = sr.querySelector('button');
    if (!balon) return false;
    var a = cubuk.getBoundingClientRect();
    var b = balon.getBoundingClientRect();
    if (!b.width || !b.height) return false;
    return !(b.right < a.left || b.left > a.right || b.bottom < a.top || b.top > a.bottom);
  }

  function uygula() {
    bekleyen = false;
    if (!host || !host.shadowRoot) return;
    var sr = host.shadowRoot;
    var dar = window.matchMedia('(max-width: 800px)').matches;
    /* Çerez bandı açıkken çubuk da balon da zaten CSS ile bandın üstünde;
       buradan ikinci bir kaydırma eklersek üst üste biner. */
    var cerez = document.body.classList.contains('cerez-bant-acik') ||
                document.body.classList.contains('cerez-ayar-acik');
    var gorunur = dar && !cerez && !cubuk.hasAttribute('hidden');

    if (gorunur && !sohbetAcik(sr)) {
      /* Önce sıfırlayıp ölç: kayık haldeyken ölçersek çakışma yok sanırız. */
      host.style.removeProperty('transform');
      if (cakisiyor(sr)) {
        var pay = cubuk.getBoundingClientRect().height + 10;
        host.style.setProperty('transform', 'translateY(-' + Math.round(pay) + 'px)', 'important');
      }
    } else {
      host.style.removeProperty('transform');
    }
  }

  function planla() {
    if (bekleyen) return;
    bekleyen = true;
    requestAnimationFrame(uygula);
  }

  function bagla(el) {
    host = el;
    if (!host.shadowRoot) return false;
    new MutationObserver(planla).observe(host.shadowRoot, { childList: true, subtree: true });
    new MutationObserver(planla).observe(cubuk, { attributes: true, attributeFilter: ['hidden'] });
    /* Çerez sınıfı gelip gittiğinde de yeniden ölç. */
    new MutationObserver(planla).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    host.addEventListener('click', function () { setTimeout(planla, 60); setTimeout(planla, 400); });
    window.addEventListener('resize', planla);
    window.addEventListener('scroll', planla, { passive: true });
    planla();
    return true;
  }

  /* Inbox betiği tema betiğinden sonra yükleniyor; elemanı bekliyoruz. */
  var mevcut = document.querySelector('shopify-chat');
  if (mevcut && bagla(mevcut)) return;

  var sayac = 0;
  var zaman = setInterval(function () {
    var el = document.querySelector('shopify-chat');
    if (el && bagla(el)) { clearInterval(zaman); return; }
    if (++sayac > 40) clearInterval(zaman);   /* ~20sn sonra vazgeç */
  }, 500);
})();


/* ─────────────────────── Erişilebilirlik (madde 8) ───────────────────────
   Mevcut menü/sepet kodunu yeniden yazmak yerine üzerine bağlanıyor:
   • Menü: aria-expanded, Escape ile kapanma, açılınca ilk bağlantıya odak,
     kapanınca odağın düğmeye dönmesi.
   • Sepet: açılınca kapatma düğmesine odak, kapanınca tetikleyiciye dönüş.
     (Escape zaten çalışıyordu.)
   • Varyant seçenekleri: role="radio" ve roving tabindex vardı ama ok tuşu
     yoktu — seçili olmayan değerlere klavyeyle hiç erişilemiyordu.        */
(function () {
  "use strict";
  var q = function (s, k) { return (k || document).querySelector(s); };
  var qa = function (s, k) { return Array.prototype.slice.call((k || document).querySelectorAll(s)); };

  /* ── Menü ───────────────────────────────────────────────────────── */
  (function () {
    var dugme = q('[data-menu-ac]');
    var katman = q('[data-menu-katman]');
    if (!dugme || !katman) return;

    dugme.setAttribute('aria-expanded', 'false');
    if (katman.id) dugme.setAttribute('aria-controls', katman.id);

    function acikMi() { return katman.classList.contains('nav-overlay--open'); }

    function kapat() {
      if (!acikMi()) return;
      katman.classList.remove('nav-overlay--open');
      document.body.classList.remove('menu-acik');
      dugme.textContent = 'Menü';
      dugme.setAttribute('aria-expanded', 'false');
      dugme.focus();
    }

    /* Düğmeye basıldıktan sonra durumu aria'ya yansıt ve odağı taşı. */
    dugme.addEventListener('click', function () {
      var acik = acikMi();
      dugme.setAttribute('aria-expanded', String(acik));
      if (acik) {
        var ilk = q('a, button', katman);
        if (ilk) ilk.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && acikMi()) { e.preventDefault(); kapat(); }
    });

    /* Menüdeki bağlantıya tıklanınca da aria senkron kalsın. */
    qa('a', katman).forEach(function (a) {
      a.addEventListener('click', function () { dugme.setAttribute('aria-expanded', 'false'); });
    });
  })();

  /* ── Sepet çekmecesi ────────────────────────────────────────────── */
  (function () {
    var sepet = q('[data-sepet]');
    if (!sepet || !window.MutationObserver) return;
    var tetikleyici = null;

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sepet-ac]');
      if (t) tetikleyici = t;
    }, true);

    var oncekiAcik = sepet.classList.contains('cart--open');
    new MutationObserver(function () {
      var acik = sepet.classList.contains('cart--open');
      if (acik === oncekiAcik) return;
      oncekiAcik = acik;
      if (acik) {
        var kapatDugme = q('[data-sepet-kapat]', sepet);
        if (kapatDugme) kapatDugme.focus();
      } else if (tetikleyici && document.contains(tetikleyici)) {
        tetikleyici.focus();
      }
      if (tetikleyici) tetikleyici.setAttribute('aria-expanded', String(acik));
    }).observe(sepet, { attributes: true, attributeFilter: ['class'] });
  })();

  /* ── Varyant seçenekleri: ok tuşlarıyla gezinme ─────────────────── */
  qa('[role="radiogroup"]').forEach(function (grup) {
    var ogeler = qa('[role="radio"]', grup);
    if (ogeler.length < 2) return;
    grup.addEventListener('keydown', function (e) {
      var i = ogeler.indexOf(document.activeElement);
      if (i < 0) return;
      var yon = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') yon = 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') yon = -1;
      else if (e.key === 'Home') yon = -i;
      else if (e.key === 'End') yon = ogeler.length - 1 - i;
      else return;
      e.preventDefault();
      var j = (i + yon + ogeler.length) % ogeler.length;
      var hedef = ogeler[j];
      /* Roving tabindex'i taşı, sonra seçimi uygula (bağlantıya git). */
      ogeler.forEach(function (o) { o.setAttribute('tabindex', '-1'); });
      hedef.setAttribute('tabindex', '0');
      hedef.focus();
      hedef.click();
    });
  });

  /* ── Çerez bandı ile sohbet balonunun çakışması ────────────────────
     Shopify Inbox'ın sohbet balonu sol altta duruyor ve çerez bandının
     en alttaki "Tercihleri yönet" düğmesinin sol ucunu örtüyordu:
     254x35'lik düğmenin %33'ü dokunulamaz haldeydi. Bant açıkken balonu
     bandın üstüne çıkarıyoruz (CSS'te kabuğun boyunu kısaltarak).
     Balona dokunulduğu anda kısıtlamayı bırakıyoruz ki sohbet paneli
     tam boyda açılsın. */
  (function () {
    var govde = document.body;
    if (!govde || !window.MutationObserver) return;

    var kok = document.documentElement;
    var elle = false;   /* kullanıcı sohbete dokunduysa bir daha karışma */
    var bekliyor = false;
    var bagli = [];

    function gorunur(el) {
      return !!el && getComputedStyle(el).display !== 'none';
    }

    function birak() {
      govde.classList.remove('cerez-bant-acik', 'cerez-ayar-acik');
      kok.style.removeProperty('--cerez-bant-h');
    }

    function tazele() {
      bekliyor = false;
      if (elle) return;
      var bant = document.getElementById('shopify-pc__banner');
      var ayar = document.getElementById('shopify-pc__prefs');
      if (gorunur(ayar)) {
        kok.style.removeProperty('--cerez-bant-h');
        govde.classList.remove('cerez-bant-acik');
        govde.classList.add('cerez-ayar-acik');
        return;
      }
      govde.classList.remove('cerez-ayar-acik');
      if (!gorunur(bant)) { birak(); return; }
      var y = Math.ceil(bant.getBoundingClientRect().height);
      if (y < 1) { birak(); return; }
      kok.style.setProperty('--cerez-bant-h', y + 'px');
      govde.classList.add('cerez-bant-acik');
    }

    /* requestAnimationFrame sekme arkadayken hiç çalışmıyor; bant o sırada
       gelirse balon kilitli kalırdı. Kısa bir zamanlayıcı her durumda döner. */
    function sirala() {
      if (bekliyor) return;
      bekliyor = true;
      setTimeout(tazele, 16);
    }

    /* Shopify'ın iki penceresi de body'nin doğrudan çocuğu olarak geliyor.
       Geldiklerinde style/class değişimlerini tek tek izliyoruz — body'nin
       tamamını subtree ile izlemek sayfadaki animasyonlar yüzünden sürekli
       tetiklenirdi. */
    function bagla() {
      ['shopify-pc__banner', 'shopify-pc__prefs'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el || bagli.indexOf(el) > -1) return;
        bagli.push(el);
        new MutationObserver(sirala).observe(el, {
          attributes: true,
          attributeFilter: ['style', 'class', 'hidden']
        });
      });
    }

    document.addEventListener('click', function (e) {
      var h = e.target;
      if (h && h.closest && h.closest('shopify-chat')) {
        elle = true;
        birak();
      }
    }, true);

    new MutationObserver(function () { bagla(); sirala(); })
      .observe(govde, { childList: true });

    window.addEventListener('resize', sirala);
    window.addEventListener('orientationchange', sirala);

    bagla();
    sirala();
    /* Shopify'ın betiği geç yüklenebiliyor; iki emniyet yoklaması. */
    setTimeout(function () { bagla(); sirala(); }, 1500);
    setTimeout(function () { bagla(); sirala(); }, 4000);
  })();
})();
